import { ServiceTimeClass } from '@mews/enums';
import { createConditionSwitch } from '@mews/fp';

export const getTimeOffsetObject = (bookablePeriod: ServiceTimeClass, timeHours: number, timeMinutes: number) =>
    createConditionSwitch([
        {
            cond: bookablePeriod === ServiceTimeClass.Night,
            value: { hours: timeHours, minutes: timeMinutes },
        },
        {
            cond: bookablePeriod === ServiceTimeClass.Hour,
            value: { hours: timeHours, minutes: timeMinutes },
        },
        {
            cond: timeMinutes !== 0,
            value: { hours: timeHours - 24 + 1, minutes: timeMinutes - 60 },
        },
        {
            cond: timeMinutes === 0,
            value: { hours: timeHours - 24, minutes: timeMinutes },
        },
    ]) || { hours: timeHours, minutes: timeMinutes };
